import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const geWishlistItem = ({ id }) => {
  return axios.get(`/wishlists/check/${id}`);
};

export const useGetWishlistItem = ({ id, config }) => {
  return useQuery({
    ...config,
    queryKey: ['wishlist', id],
    queryFn: () => geWishlistItem({ id }),
  });
};
